export const notFoundRoute = {
  path: 'not-found',
  url: '/not-found',
  loadChildren: () => import('../../../shared/components/not-found/not-found.module').then(m => m.NotFoundModule),
};
